import { Component, HostBinding, inject, input, model } from '@angular/core';
import { faEdit, faEye, faEyeSlash, faPlus, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { ShiveAnimationsService } from '../../../../core/services/rendering/shive-animations.service';
import { EditDocumentAreaService } from '../../../../core/services/features/document-editing/edit-document-area.service';
import { SectionId, SectionType } from '../../../../features/invoice-theme/theme.types';
import {
  isHiddenMeta,
  isRemovedMeta,
} from '../../../../core/constants-repository/edit-document-sections.constants';
import { InvoiceStateService } from '../../../../pages/finances/invoices/invoice-creation-editing/state-and-data-handling/invoice-state.service';

@Component({
  selector: 'app-edit-document-section-control',
  templateUrl: './edit-document-section-control.component.html',
  styleUrl: './edit-document-section-control.component.scss',
  animations: [ShiveAnimationsService.fadeAnimation],
  standalone: false,
})
export class EditDocumentSectionControlComponent {
  sectionType = input.required<SectionType>();
  sectionId = input.required<SectionId>();
  sectionHidden = model<boolean>(false);
  sectionRemoved = model<boolean>(false);
  whiteIcons = input<boolean>();

  @HostBinding('@fadeAnimation')
  public fadeAnimation = {
    // the `value` can be anything (it just has to be different
    // from `void` so :enter fires).  “in” / “out” / true / false / ''
    value: 'in',
  };

  public readonly faEdit = faEdit;
  public readonly faTrash = faTrash;
  public readonly faEye = faEye;
  public readonly faEyeSlash = faEyeSlash;
  public readonly faPlus = faPlus;

  // DI
  private readonly editDocumentAreaService = inject(EditDocumentAreaService);
  private readonly invoiceStateService = inject(InvoiceStateService);

  public editSection(): void {
    this.editDocumentAreaService.set({
      type: this.sectionType(),
      sectionId: this.sectionId(),
    });
  }

  public hideSection(): void {
    const visibility = !this.sectionHidden();
    const meta = { [isHiddenMeta]: visibility.toString() };
    this.invoiceStateService.updateContentArea(this.sectionId(), { meta });
    this.sectionHidden.set(visibility);
  }

  public toggleSection(removeSection: boolean) {
    const meta = { [isRemovedMeta]: removeSection.toString(), [isHiddenMeta]: false.toString() };
    this.invoiceStateService.updateContentArea(this.sectionId(), {
      meta,
    });
    this.sectionRemoved.set(removeSection);
  }
}
